export class IntercomConfiguration {
    constructor() {
        this.Guid = "";
        this.RtspUrl = "";
        this.UserName = null;
        this.Password = null;
    }
}
//# sourceMappingURL=IWektaIntercomsService.js.map